import { API } from "aws-amplify";

import { getAPIReq } from "./authLib";

export const callResetFromSnapshot = async ({ hubId, snapshotHubId }) => {
  const req = await getAPIReq(
    {
      query: `mutation resetFromSnapshot($snapshotHubId: String!) {
        resetFromSnapshot(snapshotHubId: $snapshotHubId) {
          snapshot {
            id
            name
          }
        }
      }`,
      variables: { snapshotHubId: snapshotHubId },
    },
    { hub: hubId }
  );
  const { data } = await API.post("HublyAPI", `/graphql`, req);

  return data;
};

export default callResetFromSnapshot;
